<div class="flex flex-col gap-8" data-testid="company-summary">
  <div>
    <h2 class="text-xl font-bold" data-testid="summary-title">
      {{ 'project.steps.totalSummary' | transloco }}
    </h2>
    <p class="text-muted-color" data-testid="summary-subtitle">
      {{ 'project.steps.companyWorkforceAllOffices' | transloco }}
    </p>
  </div>

  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    <app-workforce-kpi-card
      titleKey="project.steps.companyInfo.kpiHcTotal"
      [split]="kpis().headcount"
      testId="summary-kpi-hc"
    />
    <app-workforce-kpi-card
      titleKey="project.steps.companyInfo.kpiFteTotal"
      [split]="kpis().fte"
      digitsInfo="1.0-2"
      testId="summary-kpi-fte"
    />
  </div>

  <app-progress-bar
    [completed]="completedUnits()"
    [total]="unitCount()"
    [label]="'project.steps.companyInfo.unitsComplete' | transloco"
    testIdInfo="summary-progress-info"
    testIdBar="summary-progress-bar"
  />

  <div class="flex flex-col gap-4">
    <div class="flex justify-end">
      <p-selectbutton
        [options]="modeOptions"
        optionLabel="labelKey"
        optionValue="value"
        [allowEmpty]="false"
        [ngModel]="mode()"
        (ngModelChange)="onModeChange($event)"
        data-testid="summary-mode-selector"
      >
        <ng-template #item let-item>
          <span [attr.data-testid]="'mode-option-' + item.value">{{
            item.labelKey | transloco
          }}</span>
        </ng-template>
      </p-selectbutton>
    </div>

    <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
      <app-workforce-donut-chart
        titleKey="project.steps.companyInfo.chartHcByCategory"
        [segments]="headcountByCategory()"
        [mode]="mode()"
        testId="chart-hc-by-category"
      />
      <app-workforce-donut-chart
        titleKey="project.steps.companyInfo.chartFteByCategory"
        [segments]="fteByCategory()"
        [mode]="mode()"
        digitsInfo="1.0-2"
        testId="chart-fte-by-category"
      />
      <app-workforce-donut-chart
        titleKey="project.steps.companyInfo.chartHcByUnit"
        [segments]="headcountByUnit()"
        [mode]="mode()"
        testId="chart-hc-by-unit"
      />
    </div>
  </div>

  <section class="flex flex-col gap-6" data-testid="summary-hr-section">
    <h3 class="text-lg font-semibold">
      {{ 'project.steps.companyInfo.hrSectionTitle' | transloco }}
    </h3>
    <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <app-workforce-donut-chart
        titleKey="project.steps.companyInfo.chartHrByUnit"
        [segments]="hrByUnit()"
        [mode]="mode()"
        testId="chart-hr-by-unit"
      />
      <div class="card flex flex-col gap-3 p-4" data-testid="care-ratio-card">
        <span class="text-muted-color text-sm">
          {{ 'project.steps.companyInfo.careRatio' | transloco }}
        </span>
        @if (hasCareRatio()) {
          <span class="text-3xl font-bold text-white" data-testid="care-ratio-value">
            {{ careRatioValue() | appNumber: '1.1-1' }}
          </span>
          <span class="text-muted-color text-sm">
            {{ 'project.steps.companyInfo.careRatioHint' | transloco }}
          </span>
          <app-benchmark-ray [ratio]="careRatioValue()" />
          <span class="text-sm" data-testid="care-ratio-position">
            {{ careRatioPositionKey() | transloco }}
            ({{
              'project.steps.companyInfo.careRatioTypicalRange' | transloco: typicalRangeParams
            }})
          </span>
        } @else {
          <span class="text-orange text-sm" data-testid="care-ratio-hint">
            {{ 'project.steps.companyInfo.careRatioNoHrFte' | transloco }}
          </span>
        }
      </div>
    </div>

    <p-panel
      [toggleable]="true"
      toggler="header"
      [collapsed]="benchmarksCollapsed()"
      (collapsedChange)="onBenchmarksCollapsedChange($event)"
      data-testid="benchmarks-panel"
    >
      <ng-template #header>
        <span class="font-semibold">
          {{ 'project.steps.companyInfo.benchmarksTitle' | transloco }}
        </span>
      </ng-template>
      <ng-template #headericons let-collapsed>
        <i class="pi" [class.pi-chevron-down]="collapsed" [class.pi-chevron-up]="!collapsed"></i>
      </ng-template>
      <p class="text-muted-color mb-4 text-sm">
        {{ 'project.steps.companyInfo.benchmarksIntro' | transloco }}
      </p>
      <ul class="flex flex-col" data-testid="benchmark-rows">
        @for (reference of benchmarkReferences; track reference.labelKey) {
          <li class="benchmark-row flex items-center justify-between gap-4 py-2 text-sm">
            <span class="flex flex-col">
              <span>{{ reference.labelKey | transloco }}</span>
              <span class="text-muted-color text-xs">{{ reference.source }}</span>
            </span>
            <span class="font-mono whitespace-nowrap font-semibold">{{ reference.value }}</span>
          </li>
        }
      </ul>
      <div class="mt-4">
        <h4 class="mb-2 font-semibold">
          {{ 'project.steps.companyInfo.benchmarkSources' | transloco }}
        </h4>
        <ul class="flex flex-col gap-1">
          @for (source of benchmarkSources; track source.url) {
            <li>
              <a
                class="text-blue text-sm underline"
                [href]="source.url"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ source.title }}
              </a>
            </li>
          }
        </ul>
      </div>
    </p-panel>
  </section>
</div>
